module.exports = __webpack_public_path__ + "img/Logo_of_Kerala_Forest_Department.08eb9e26.png";